var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3443 5.345L12.9877 2.98833C12.6752 2.67583 12.251 2.5 11.8093 2.5H5.83268C4.91185 2.5 4.16602 3.24583 4.16602 4.16667V15.8333C4.16602 16.7542 4.91185 17.5 5.83268 17.5H14.166C15.0868 17.5 15.8327 16.7542 15.8327 15.8333V6.52333C15.8327 6.08167 15.6568 5.6575 15.3443 5.345V5.345Z",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 6.66667H12.4993C12.0393 6.66667 11.666 6.29333 11.666 5.83333V2.5",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/Path.e8ab9f38aa767cb5a59e2311bc860661.svg";
export { ForwardRef as ReactComponent };